import { getAssetUrl } from '@/utils/assetUtils'
import classnames from 'classnames'
import Image from 'next/image'

export interface ChapterCardProps {
  chapterNumber: number
  active?: boolean
}

export default function ChapterCard({ chapterNumber, active = false }: ChapterCardProps) {
  const cardWrapperClass = classnames({
    'rounded-lg shadow-md overflow-hidden text-center': true,
    'w-[200px] h-[140px] md:w-[248px] md:h-[168px] transition-all duration-300': !active,
    'w-[260px] h-[200px] md:w-[422px] md:h-[316px] transition-all duration-300 border-2 border-white': active,
  })

  const imagePath = getAssetUrl(`/thumbs/chapter-${chapterNumber}/thumb-1.jpg`)

  return (
    <div className={cardWrapperClass}>
      <Image
        width={422}
        height={316}
        src={imagePath}
        alt={`Chapter ${chapterNumber}`}
        className="object-cover w-full h-full"
      />
    </div>
  )
}

export { ChapterCard }
